// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"l3l29":[function(require,module,exports) {
require("140496be15e93fdf").register(require("856e501f13bf84ff").getBundleURL("hwbR1"), JSON.parse('["hwbR1","index.b26dffc5.js","6pYmK","icons.7bb96926.svg","4vDYv","index.1b5fdb01.js","9Pxhc","index.cd8c9dd4.js"]'));

},{"140496be15e93fdf":"44XlC","856e501f13bf84ff":"7Ve2W"}],"44XlC":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"7Ve2W":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"2nzDi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _webImmediateJs = require("core-js/modules/web.immediate.js");
var _modelJs = require("./model.js");
var _recipeViewJs = require("./views/recipeView.js");
var _recipeViewJsDefault = parcelHelpers.interopDefault(_recipeViewJs);
var _searchViewJs = require("./views/searchView.js");
var _searchViewJsDefault = parcelHelpers.interopDefault(_searchViewJs);
var _resultsViewJs = require("./views/resultsView.js");
var _resultsViewJsDefault = parcelHelpers.interopDefault(_resultsViewJs);
var _paginationViewJs = require("./views/paginationView.js");
var _paginationViewJsDefault = parcelHelpers.interopDefault(_paginationViewJs);
var _bookmarksViewJs = require("./views/bookmarksView.js");
var _bookmarksViewJsDefault = parcelHelpers.interopDefault(_bookmarksViewJs);
var _addRecipeViewJs = require("./views/addRecipeView.js");
var _addRecipeViewJsDefault = parcelHelpers.interopDefault(_addRecipeViewJs);
var _themeViewJs = require("./views/themeView.js");
var _themeViewJsDefault = parcelHelpers.interopDefault(_themeViewJs);
var _configJs = require("./config.js");
var _runtime = require("regenerator-runtime/runtime");
// if (module.hot) {
//   module.hot.accept();
// }
const controlRecipes = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        if (document.documentElement.clientWidth <= 600) (0, _recipeViewJsDefault.default).scrollToRecipe();
        (0, _recipeViewJsDefault.default).renderSpinner();
        // 1) Update results view to mark selected search result
        (0, _resultsViewJsDefault.default).update(_modelJs.getSearchResultsPage());
        // 2) Loading recipe
        await _modelJs.loadRecipe(id);
        // 3) Rendering recipe
        (0, _recipeViewJsDefault.default).render(_modelJs.state.recipe);
        // 4) Updating bookmarks view
        (0, _bookmarksViewJsDefault.default).update(_modelJs.state.bookmarks);
    } catch (err) {
        console.error(`${err.message} \u{26A0}\u{26A0}\u{26A0}`);
        (0, _recipeViewJsDefault.default).renderError();
    }
    // rendering the recipe without the nutritional data
    if (!_modelJs.state.recipe.calories) {
        // 1) Rendering recipe
        (0, _recipeViewJsDefault.default).render(_modelJs.state.recipe);
        // 2) Updating bookmarks view
        (0, _bookmarksViewJsDefault.default).update(_modelJs.state.bookmarks);
    }
};
const controlSearchResults = async function() {
    // 1) Get search query and trim it to remove whitespace
    const query = (0, _searchViewJsDefault.default).getQuery().trim();
    // 2) Check if the query is empty after trimming
    if (!query) return;
    try {
        // Render the spinner only after validating the query is not empty
        (0, _resultsViewJsDefault.default).renderSpinner();
        // 3) Proceed with loading search results if query is valid
        await _modelJs.loadSearchResults(query);
        // 4) Render results
        (0, _resultsViewJsDefault.default).render(_modelJs.getSearchResultsPage());
        // 5) Render pagination buttons
        (0, _paginationViewJsDefault.default).render(_modelJs.state.search);
    } catch (err) {
        console.error(err);
        // Provide feedback to the user upon error
        (0, _resultsViewJsDefault.default).renderError("Failed to load search results. Please try again.");
    }
};
const controlPagination = function(goToPage) {
    //1) Render NEW results
    (0, _resultsViewJsDefault.default).render(_modelJs.getSearchResultsPage(goToPage));
    //2) Render NEW pagination buttons
    (0, _paginationViewJsDefault.default).render(_modelJs.state.search);
};
const controlServings = function(newServings) {
    // Update the recipe servings (in state)
    _modelJs.updateServings(newServings);
    // Update the recipe view
    // recipeView.render(model.state.recipe);
    (0, _recipeViewJsDefault.default).update(_modelJs.state.recipe);
};
const controlAddBookmark = function() {
    //1) Add/remove bookmark
    if (!_modelJs.state.recipe.bookmarked) _modelJs.addBookmark(_modelJs.state.recipe);
    else _modelJs.deleteBookmark(_modelJs.state.recipe.id);
    //2) Render bookmarks
    (0, _recipeViewJsDefault.default).update(_modelJs.state.recipe);
    // 3) Render bookmarks
    (0, _bookmarksViewJsDefault.default).render(_modelJs.state.bookmarks);
};
const controlBookmarks = function() {
    (0, _bookmarksViewJsDefault.default).render(_modelJs.state.bookmarks);
};
const controlAddRecipe = async function(newRecipe) {
    try {
        // Show loading spinner
        (0, _addRecipeViewJsDefault.default).renderSpinner();
        //Upload the new recipe data
        await _modelJs.uploadRecipe(newRecipe);
        //Render recipe
        (0, _recipeViewJsDefault.default).render(_modelJs.state.recipe);
        //Success message
        (0, _addRecipeViewJsDefault.default).renderMessage();
        //Render bookmarks view
        (0, _bookmarksViewJsDefault.default).render(_modelJs.state.bookmarks);
        //Change ID in the URL
        window.history.pushState(null, "", `#${_modelJs.state.recipe.id}`);
    } catch (err) {
        console.error(err);
        (0, _addRecipeViewJsDefault.default).renderError(err.message);
    }
    //Close form window
    setTimeout(function() {
        (0, _addRecipeViewJsDefault.default).toggleWindow();
        location.reload();
    }, (0, _configJs.MODAL_CLOSE_SEC) * 1000);
};
const controlAddToShoppingList = function(ingredient) {
    _modelJs.addIngredient(ingredient);
};
const controlPlanMeal = async function(mealData) {
    try {
        await _modelJs.addPlannedMeal(mealData);
    } catch (err) {
        (0, _recipeViewJsDefault.default).renderError("We could not get the recipe data. Try again!");
    }
};
const controlResetApp = function() {
    _modelJs.clearLocalStorage();
};
const controlTheme = function(actualTheme) {
    let newTheme = "light";
    if (actualTheme === "light") newTheme = "dark";
    _modelJs.changeTheme(newTheme);
    (0, _themeViewJsDefault.default).setTheme(newTheme);
};
const initTheme = function() {
    (0, _themeViewJsDefault.default).setTheme(_modelJs.state.theme);
};
const init = function() {
    //Home events
    (0, _recipeViewJsDefault.default).addHandlerRender(controlRecipes);
    (0, _recipeViewJsDefault.default).addHandlerUpdateServings(controlServings);
    (0, _recipeViewJsDefault.default).addHandlerAddBookmark(controlAddBookmark);
    (0, _recipeViewJsDefault.default).addHandlerSubmitPlan(controlPlanMeal);
    (0, _recipeViewJsDefault.default).addHandlerAddIngredient(controlAddToShoppingList);
    (0, _searchViewJsDefault.default).addHandlerSearch(controlSearchResults);
    (0, _searchViewJsDefault.default).updatePlaceholder();
    window.addEventListener("resize", (0, _searchViewJsDefault.default).updatePlaceholder.bind((0, _searchViewJsDefault.default)));
    (0, _paginationViewJsDefault.default).addHandlerClick(controlPagination);
    (0, _bookmarksViewJsDefault.default).addHandlerRender(controlBookmarks);
    (0, _addRecipeViewJsDefault.default).addHandlerUpload(controlAddRecipe);
    initTheme();
    (0, _themeViewJsDefault.default).addHandlerChangeTheme(controlTheme);
};
init();

},{"core-js/modules/web.immediate.js":"b7Fhu","./model.js":"5XrL7","./views/recipeView.js":"gcMxR","./views/searchView.js":"6L6eH","./views/resultsView.js":"65N7q","./views/paginationView.js":"3vGkl","./views/bookmarksView.js":"9IfoN","./views/addRecipeView.js":"3CEDh","./views/themeView.js":"htPRE","./config.js":"cTPit","regenerator-runtime/runtime":"j1Ujo","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"6L6eH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class SearchView {
    _parentElement = document.querySelector(".search");
    getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            handler();
        });
    }
    updatePlaceholder() {
        const input = this._parentElement.querySelector(".search__field");
        const placeholderText = window.innerWidth <= 900 ? "Search recipes..." : "Search over 1,000,000 recipes...";
        input.setAttribute("placeholder", placeholderText);
    }
}
exports.default = new SearchView();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"65N7q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _previewViewJs = require("./previewView.js");
var _previewViewJsDefault = parcelHelpers.interopDefault(_previewViewJs);
class ResultsView extends (0, _viewJsDefault.default) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipes found for your query. Please try again!";
    _message;
    _generateMarkup() {
        return this._data.map((result)=>(0, _previewViewJsDefault.default).render(result, false)).join("");
    }
}
exports.default = new ResultsView();

},{"./View.js":"lslfl","./previewView.js":"edsmS","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"edsmS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
class PreviewView extends (0, _viewJsDefault.default) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
    <li class="preview">
    <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
    <figure class="preview__fig">
        <img src="${this._data.image}" alt="Test" />
    </figure>
    <div class="preview__data">
        <h4 class="preview__title">${this._data.title}</h4>
        <p class="preview__publisher">${this._data.publisher}</p>
        <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
          <svg>
            <use href="${0, _iconsSvgDefault.default}#icon-user"></use>
          </svg>
        </div>
    </div>
    </a>
    </li>  
    `;
    }
}
exports.default = new PreviewView();

},{"./View.js":"lslfl","url:../../img/icons.svg":"cgUd1","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"cgUd1":[function(require,module,exports) {
module.exports = require("f9d19843c2e34033").getBundleURL("hwbR1") + "icons.7bb96926.svg";

},{"f9d19843c2e34033":"7Ve2W"}],"3vGkl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
class PaginationView extends (0, _viewJsDefault.default) {
    _parentElement = document.querySelector(".pagination");
    addHandlerClick(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    _generateMarkup() {
        const currentPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        //Page 1, and there are other pages
        if (currentPage === 1 && numPages > 1) return `
        <button data-goto="${currentPage + 1}" class="btn--inline pagination__btn--next">
            <span>Page ${currentPage + 1}</span>
            <svg class="search__icon">
              <use href="${0, _iconsSvgDefault.default}#icon-arrow-right"></use>
            </svg>
        </button>
        <div class="pagination__label">
            <span class="pagination__label-text">Page ${currentPage} out of ${numPages}</span>
        </div>
      `;
        //Last page
        if (currentPage === numPages && numPages > 1) return `
        <button data-goto="${currentPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${0, _iconsSvgDefault.default}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currentPage - 1}</span>
        </button>
        <div class="pagination__label">
            <span class="pagination__label-text">Page ${currentPage} out of ${numPages}</span>
        </div>
      `;
        //Other page
        if (currentPage < numPages) return `
        <button data-goto="${currentPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${0, _iconsSvgDefault.default}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currentPage - 1}</span>
        </button>
        <button data-goto="${currentPage + 1}" class="btn--inline pagination__btn--next">
            <span>Page ${currentPage + 1}</span>
            <svg class="search__icon">
                <use href="${0, _iconsSvgDefault.default}#icon-arrow-right"></use>
            </svg>
        </button>
        <div class="pagination__label">
            <span class="pagination__label-text">Page ${currentPage} out of ${numPages}</span>
        </div>
      `;
        //Page 1, and there are no other pages
        return `
    `;
    }
}
exports.default = new PaginationView();

},{"./View.js":"lslfl","url:../../img/icons.svg":"cgUd1","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"9IfoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _previewViewJs = require("./previewView.js");
var _previewViewJsDefault = parcelHelpers.interopDefault(_previewViewJs);
class BookmarksView extends (0, _viewJsDefault.default) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = "No bookmarks yet. Find a nice recipe and bookmark it ;)";
    _message = "";
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return this._data.map((bookmarks)=>(0, _previewViewJsDefault.default).render(bookmarks, false)).join("");
    }
}
exports.default = new BookmarksView();

},{"./View.js":"lslfl","./previewView.js":"edsmS","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"3CEDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _viewJs = require("./View.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
class AddRecipeView extends (0, _viewJsDefault.default) {
    _parentElement = document.querySelector(".upload");
    _message = "Recipe was succesfully uploaded";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnOpen = document.querySelector(".page-options__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    toggleWindow() {
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
    }
    _addHandlerShowWindow() {
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    _addHandlerHideWindow() {
        this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
        this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    }
    addHandlerUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ]; //this points to the form inside of the handler
            const data = Object.fromEntries(dataArr);
            console.log(data);
            handler(data);
        });
    }
    _generateMarkup() {}
}
exports.default = new AddRecipeView();

},{"./View.js":"lslfl","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}]},["l3l29","2nzDi"], "2nzDi", "parcelRequire3a11")

//# sourceMappingURL=index.b26dffc5.js.map
